<div class="sig-wrap" [class.disabled]="disabled">
    <signature-pad #pad [options]="padOptions" (drawEnd)="onDrawEnd()"></signature-pad>
    <div class="sig-actions">
        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="clear()" [disabled]="disabled">
            پاک کردن امضا
        </button>
        <img *ngIf="hasPreview" [src]="value" class="sig-preview" alt="پیش‌نمایش امضا" />
    </div>
</div>
